import axios from "axios";

// send Reset Password Link
export function sendResetPasswordLink({
  email
}) {
  return new Promise((resolve, reject) => {
    axios.post("distributor/public/api/v1/auth/send-reset-password-link-email", {
      email: email,
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}